<template>
    <div>
        <div class="warp-block">
            <div class="common-width common-space-between">
                <div class="blockNUMBER common-items-center">
                    <div>
                        <span  class="number">{{ accountRecharge | moneyFromat }}</span>
                        <div class="title">钱包充值(元)</div>
                    </div>
                </div>
                <div class="blockNUMBER common-items-center">
                    <div>
                        <span  class="number">{{ smsRecharge | moneyFromat }}</span>
                        <div class="title">短信充值(元)</div>
                    </div>
                </div>
                <div class="blockNUMBER common-items-center">
                    <div>
                        <span  class="number">{{ voiceRecharge | moneyFromat }}</span>
                        <div class="title">语音充值(元)</div>
                    </div>
                </div>
                <div class="blockNUMBER common-items-center">
                    <div>
                        <span  class="number">{{ iotrecharge | moneyFromat }}</span>
                        <div class="title">物联网卡续费(元)</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="announ">
            <div class="block">
                <div id="mainC" ref="chart"></div>
            </div>
        </div>
    </div>
</template>
<script>
import {url,operate} from '@/utils/config'
import {getFun} from '@/utils/httpFun'
export default {
    components: {

    },
    props: {
        width: {
            type: Number,
            default: 100
        }
    },
    data: () => ({
        accountRecharge:0.00,
        smsRecharge:0.00,
        iotrecharge:0.00,
        totalRecharge:0.00,
        voiceRecharge:0.00,
        myChart: {},
        data:[]
    }),
    computed: {
        refreshStr() {
            return this.$store.state.windowwidth || this.$store.state.windowwidth;
        }
    },
    watch: {
        refreshStr(val) {
            if (val) {
                this.myChart.resize()
            }
        }
    },
    mounted() {
        this.getInfo()
    },
    methods: {
        formatter(num){
            return num.toFixed(2);
        },
        getInfo() {
            getFun(operate.INCOMEMONEYPING,{},res=>{
                this.voiceRecharge=res.data.voiceRecharge
                this.totalRecharge=res.data.totalRecharge
                this.iotrecharge=res.data.iotrecharge
                this.smsRecharge=res.data.smsRecharge
                this.accountRecharge=res.data.accountRecharge

                console.log('==========res',res)

                this.data = [
                    { value:Math.round(this.voiceRecharge / this.totalRecharge * 10000) / 100, name: '语音充值',count:this.voiceRecharge},
                    { value:Math.round(this.smsRecharge / this.totalRecharge * 10000) / 100, name: '短信充值',count:this.smsRecharge},
                    { value:Math.round(this.accountRecharge / this.totalRecharge * 10000) / 100, name: '钱包充值',count:this.accountRecharge},
                    { value:Math.round(this.iotrecharge / this.totalRecharge * 10000) / 100, name: '物联网卡续费',count:this.iotrecharge}
                ]
                this.init()
            })
        },
        init() {
            let myChart = this.$_echarts.init(document.getElementById('mainC'))
            this.myChart = myChart
            var option = {
                tooltip: {
                    show:true,
                    trigger:'item',
                    formatter:function (param){
                        // console.log('===========param',param);
                        return `
                            ${param.data.name}<br>
                            金额:${param.data.count}<br>
                            占比:${param.data.value}%
                        `
                    }
                },
                series: [
                    {
                        color: ['#00ABFF', '#00D573', '#FFC300', '#00CCFF'],
                        type: 'pie',
                        radius: ['65%', '80%'],
                        labelLine: {
                            length: 25,
                            length2: 0,
                            maxSurfaceAngle: 20
                        },
                        label: {
                            alignTo: 'edge',
                            formatter: '{name|{b}}\n{time|{c}%}',
                            minMargin: 5,
                            edgeDistance: '5%',
                            lineHeight: 30,
                            rich: {
                                name: {
                                    color: "#474E5F",
                                    fontSize: 16,
                                },
                                time: {
                                    fontSize: 19,
                                    color: 'rgb(44, 221, 225)'
                                }
                            }
                        },
                        itemStyle: {
                            borderWidth: 7, 
                            borderColor: '#fff',
                            borderRadius: 10,
                        },
                        data:this.data
                    }
                ]
            }
            this.myChart.setOption(option);
        }
    },
}
</script>
<style lang="scss" scoped>
.warp-block {
    padding: 20px;
    box-sizing: border-box;
    padding-top: 0;
    background-color: white;
    .blockNUMBER {
        overflow: hidden;
        height: 126px;
        width: calc(25% - 15px);
        background: #FFFBF1;
        border: 1px solid rgba(255, 231, 191, 1);
        border-radius: 12px;
        padding-left: 26px;
        box-sizing: border-box;
        .number {
            font-family: DINAlternate-Bold;
            font-size: 38px;
            color: #2F3F56;
            letter-spacing: 0;
            line-height: 38px;
            font-weight: 700;
        }

        @media screen and (max-Width:1620px) {
            .number{
                font-size: 27px;
            }
        }

        @media screen and (max-Width:1400px) {
            .number{
                font-size: 23px;
            }
        }
        @media screen and (max-Width:1300px) {
            .number{
                font-size: 20px;
            }
        }

        .title {
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #4D5C72;
            letter-spacing: 0;
            line-height: 18px;
            font-weight: 400;
            padding-top: 10px;
        }
    }
}
.announ {
    background: #FFFFFF;
    border-radius: 0 0 10px 10px;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    .block {
        height:300px;
        position: relative;
        padding: 30px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-around;
        border: 1px solid rgba($color: #000000, $alpha: 0.05);
        border-radius:10px;

    }
}
#mainC{
    width: 100%;
    height: 100%;
}

</style>
